import {FC} from 'react';
import clsx from 'clsx';
import Button from 'components/Button';
import {setUrl} from 'utils/request';

type BackButtonProps = {
    backUrl: string;
    className?: string;
    label: string;
};

const BackButton: FC<BackButtonProps> = ({backUrl, className, label}) => (
    <Button
        aria-label="back-button"
        className={clsx(
            className,
            'w-fit inline-block justify-center align-middle',
        )}
        icon="arrow_left"
        isAlignedCenter={false}
        kind="tertiary"
        onClick={() => {
            const searchParams = new URLSearchParams(window.location.search);

            if (searchParams.has('history')) {
                window.history.back();
            } else {
                setUrl(backUrl);
            }
        }}
        size="xs"
    >
        {label}
    </Button>
);

export default BackButton;
